import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Api, BaseUrl } from "../../Config/Api";
import { toast } from "react-toastify";
import { persistor } from "../../Redux/Store";
import { useSelector } from "react-redux";

const AdminLogout = () => {
  const [isloading , setLoading] = useState(false)
  const [showDialog, setShowDialog] = useState(false);
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const navigate = useNavigate();
  const token = sessionStorage.getItem("authToken");
  const profileData = useSelector((state) => state.employeeData?.profile)
  useEffect(() => {
    setShowDialog(true)
  }, []);

  const employeeLogout = async () => {
    setLoading(true);
    try {
      const formDataToSend = new FormData();
      formDataToSend.append("email", profileData?.email);
      formDataToSend.append("type", profileData?.type);

      const response = await axios.post(
        `${BaseUrl}${Api.LOGOUT_WFHLOCATION_IMAGE}`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            "X-Company-ID": userDetails.company_id,
          },
        }
      );

      setLoading(false);
      if (response?.data?.valid == false) {
        toast.error(response?.data?.mssg);
      } else if (response?.data?.success == false) {
        toast.error(response?.data?.mssg);
      } else {
        toast.success(response?.data?.mssg);
        sessionStorage.removeItem("authToken");
        await persistor.flush();
        await persistor.purge();
        window.location.reload();
        sessionStorage.clear();
        localStorage.clear();
        window.location = "/login"
      }
    } catch (error) {
      setLoading(false);
      console.error("Login error:", error);
      toast.error("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {showDialog && (
        <div className="dialog-backdrop">
          <div className="dialog">
            <p>Alert!</p>
            <p>Are you sure? You want to logout?</p>
            <div className="dialog-buttons">
              <button onClick={() => employeeLogout()} className="confirm-btn">
              {isloading ? "Loading ...":"Yes"} 
              </button>
              <button
                onClick={() => {
                  setShowDialog(false);
                  navigate(-1);
                }}
                className="cancel-btn"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLogout;
